import { Dispatch, SetStateAction } from "react";
import { ButtonNavStyled } from "./stylesButton";


type iButtonNav = {
  showModal: Dispatch<SetStateAction<boolean>>;
  $backgroundColor: string;
  $color: string;
  children: React.ReactNode;
}


export const ButtonNav = ({
  showModal,
  $backgroundColor,
  $color,
  children,
}: iButtonNav) => {
  return (
    <ButtonNavStyled
      $backgroundColor={$backgroundColor}
      $color={$color}
      onClick={() => showModal(true)}
    >
      {children}
    </ButtonNavStyled>
  );
};
